import { ModalTable, ProductNameColumn, KitProductLine } from "./styles";
import { useKitProducts } from "../../hooks/queries/useKitProducts";
import Product from "types/Product";
interface ModalContentProps {
  product: Product;
}

const ModalContent = ({ product }: ModalContentProps) => {
  const { data: kitProducts = [], isLoading: loading } = useKitProducts(
    product.uf_kit ? { ufKit: product.uf_kit } : null,
    !!product.uf_kit && product.uf_kit.length > 0
  );

  return (
    <div className="content">
      <ModalTable>
        <thead>
          <tr>
            <th>Cód.</th>
            <th>Mercadoria</th>
            <th>Qtd</th>
            <th>Desc (%)</th>
            <th>Preço</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={5}>Carregando produtos...</td>
            </tr>
          ) : (
            kitProducts.map(product => (
              <KitProductLine key={product.codigo}>
                <td>{product.codigo}</td>
                <ProductNameColumn>{product.nome}</ProductNameColumn>
                <td>{product.quantidade}</td>
                <td>{product.formattedDesconto}</td>
                <td>{product.formattedPreco}</td>
              </KitProductLine>
            ))
          )}
        </tbody>
      </ModalTable>
    </div>
  );
};

export default ModalContent;
